const generateUrlAsset = (append: string) => {
    return window.location.protocol + '//' + window.location.hostname + '/assets/' + append;
};

export const generateUrlImage = (imageName: string) => {
    return generateUrlAsset('images/' + imageName);
};
